'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clamp = require('../../../common/clamp');

var _clamp2 = _interopRequireDefault(_clamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returs next item that shoud be selected.
 * If the item has something on the right it should change to that one
 * if not it should check the one on the left.
 * @param  {Stirng|Number} id
 * @param  {String[]|Number[]} value
 * @return {String|Number} newActivetag
 */
function getNewActiveTagOnRemove(_ref) {
  var id = _ref.id,
      value = _ref.value,
      dir = _ref.dir;

  dir = dir || -1;
  if (!Array.isArray(value) || value.length === 1) {
    return null;
  }
  var newActiveTag = null;
  var currentIndex = value.indexOf(id);
  var lastIndex = value.length - 1;
  var newIndex = (0, _clamp2.default)(currentIndex + dir, 0, lastIndex);
  if (dir == 1 && currentIndex === lastIndex) {
    newIndex = (0, _clamp2.default)(currentIndex - 1, 0, lastIndex);
  }

  if (dir == -1 && currentIndex == 0 && lastIndex > 0) {
    newIndex = 1;
  }

  newActiveTag = value[newIndex];

  return newActiveTag;
} /**
   * Copyright (c) 2015-present, Zippy Technologies
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

exports.default = getNewActiveTagOnRemove;